/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type RotateCredentialsRequestBody = {
  oauthClientId: string;
  oauthClientSecret: string;
};

/** @internal */
export type RotateCredentialsRequestBody$Outbound = {
  oauth_client_id: string;
  oauth_client_secret: string;
};

/** @internal */
export const RotateCredentialsRequestBody$outboundSchema: z.ZodMiniType<
  RotateCredentialsRequestBody$Outbound,
  RotateCredentialsRequestBody
> = z.pipe(
  z.object({
    oauthClientId: z.string(),
    oauthClientSecret: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      oauthClientId: "oauth_client_id",
      oauthClientSecret: "oauth_client_secret",
    });
  }),
);

export function rotateCredentialsRequestBodyToJSON(
  rotateCredentialsRequestBody: RotateCredentialsRequestBody,
): string {
  return JSON.stringify(
    RotateCredentialsRequestBody$outboundSchema.parse(
      rotateCredentialsRequestBody,
    ),
  );
}
